import { CircularProgress, SxProps } from '@mui/material';

type LoaderProps = {
  sx?: SxProps;
  size?: number;
};
export const Loader = ({ size, sx }: LoaderProps) => {
  return <CircularProgress size={size} sx={sx} />;
};
